import { useContext } from "react";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LayoutContext } from "../../context/LayoutContext";

export default function MobileTopBar() {
  const { setMobileOpen } = useContext(LayoutContext);
  const isMobile = useMediaQuery("(max-width:767px)");

  if (!isMobile) return null;

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={() => setMobileOpen(true)}
        >
          <MenuIcon />
        </IconButton>

        <Typography fontWeight={800} sx={{ ml: 1 }}>
          CRM
        </Typography>

        <Box sx={{ flexGrow: 1 }} />
      </Toolbar>
    </AppBar>
  );
}
